import React, { useState, useEffect, useRef, Fragment } from "react"
import InfiniteScroll from "react-infinite-scroll-component"

import {
  OrdersTableHeader,
  InfiniteScrollLoading,
  OrderTableRow,
  OrdersEmptyList,
  PageLoader
} from "components"
import {
  filterDuplicatedOrders,
  isOrderForThisUser,
  socketConnection
} from "utils"
import { getOrders } from "services"
import CoFooter from "./CoFooter"
import classes from "./index.module.scss"

const CanceledOrders = (props) => {
  const { orderCode, filters } = props

  const [skip, setSkip] = useState(0)
  const [orders, setOrders] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [selectedOrders, setSelectedOrders] = useState({})

  const unmount = useRef(false)

  const onCanceledOrderChanges = (jsonMessage) => {
    const message = JSON.parse(jsonMessage)

    const event = message.key

    if (event !== "orderUpdated") return

    const order = message.value.order

    if (!isOrderForThisUser(order)) return

    setOrders(prev => {
      if (prev === null) return prev

      const exists =
        prev.some(o => o._id === order._id)

      if (!exists && order.orderStatus !== "canceled") return prev

      return exists
        ? prev.map(o => o._id === order._id ? order : o)
        : [order, ...prev]
    })
  }

  const handleSelectAll = (checked) => {
    if (!checked) {
      return setSelectedOrders({})
    }

    const selectedOrders = {}

    orders.forEach((o) => {
      selectedOrders[o._id] = o
    })

    setSelectedOrders(selectedOrders)
  }

  const handleLoadMore = async () => {
    try {
      const response =
        await getOrders({
          skip,
          limit: filters.limit,
          sortBy: "newstOrder",
          code: orderCode,
          isPaymentProblematic: false,
          addedBySystem: filters.addedBySystem,
          branchId: filters.branch?.value,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          accountId: filters.account?.value,
          addedByAccountId: filters.addedByAccount?.value,
          statusMultiple: filters.statusMultiple,
          isViewed: filters.isViewed ? undefined : false
        })

      if (unmount.current) return

      response.length !== filters.limit
        ? setHasMore(false)
        : setSkip(prev => prev += filters.limit)

      const filteredOrders =
        filterDuplicatedOrders(
          orders,
          response
        )

      setOrders(prev => [...prev, ...filteredOrders])
    } catch (err) {
      console.log(err)
    }
  }

  const GetOrders = async () => {
    if (orders !== null) {
      setSkip(0)

      setSelectedOrders({})

      setHasMore(true)

      setOrders(null)
    }

    try {
      const response =
        await getOrders({
          skip: 0,
          limit: filters.limit,
          sortBy: "newstOrder",
          code: orderCode,
          isPaymentProblematic: false,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          addedBySystem: filters.addedBySystem,
          branchId: filters.branch?.value,
          accountId: filters.account?.value,
          addedByAccountId: filters.addedByAccount?.value,
          statusMultiple: filters.statusMultiple,
          isViewed: filters.isViewed ? undefined : false
        })

      if (unmount.current) return

      response.length !== filters.limit
        ? setHasMore(false)
        : setSkip(prev => prev += filters.limit)

      setOrders(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    GetOrders()
  }, [orderCode, filters])

  useEffect(() => {
    const socket = socketConnection.getSocket()

    socket.on("basicEmit", onCanceledOrderChanges)

    unmount.current = false

    return () => {
      unmount.current = true

      socket.removeListener("basicEmit", onCanceledOrderChanges)
    }
  }, [])

  if (orders === null) return <PageLoader />

  const noOrders =
    !hasMore && orders.length === 0

  const allSelected =
    orders.length !== 0 &&
    Object.keys(selectedOrders).length === orders.length

  return (
    <Fragment>
      <div
        id="scrollable-div"
        className={classes["table-container"]}
      >
        <InfiniteScroll
          hasMore={hasMore}
          dataLength={skip}
          next={handleLoadMore}
          style={{ overflow: "unset" }}
          scrollableTarget="scrollable-div"
          loader={<InfiniteScrollLoading />}
          scrollThreshold="100px"
        >
          <table className={classes["table"]}>
            <OrdersTableHeader
              onSelectAll={handleSelectAll}
              allSelected={allSelected}
            />
            {!noOrders
              ?
              <tbody>
                {orders.map(order =>
                  <OrderTableRow
                    key={order._id}
                    order={order}
                    setOrders={setOrders}
                    isSelected={!!selectedOrders[order._id]}
                    setSelectedOrders={setSelectedOrders}
                    showCheckbox={order.orderStatus === "canceled"}
                  />
                )}
              </tbody>
              :
              <OrdersEmptyList />
            }
          </table>
        </InfiniteScroll>
      </div>

      <CoFooter
        setOrders={setOrders}
        selectedOrders={selectedOrders}
        setSelectedOrders={setSelectedOrders}
      />
    </Fragment>
  )
}

export default CanceledOrders